import { Component, HostBinding, Input, OnInit, input } from '@angular/core';

import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { AppDataService } from '../../../core/services/app-data.service';

@Component({
    selector: 'epmax-loader',
    imports: [LottieComponent],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
   
    isAbsolute = input<boolean>(false);
    withOverlay = input<boolean>(false);
    @Input('options') options!: AnimationOptions;
    //add to host class if position is absolute
    @HostBinding('class.absolute-position') get _isAbsolute() {
        return this.isAbsolute();
    }
    @HostBinding('class.with-overlay') get _withOverlay() {
        return this.withOverlay();
    }

    constructor(private configService: AppDataService) {
        
        if (!this.options && !!configService.brandingSettings?.loader) {
            const loaderAsBase64 = configService.brandingSettings.loader;
            const base64DataUrl = loaderAsBase64?.split(',')[1];
            const jsonString = atob(base64DataUrl);
            const jsonObject = JSON.parse(jsonString);
            this.options = { animationData: jsonObject, loop: true, autoplay: true };

        }
        else {
            this.options=  {
                 path: '/assets/epm.json',
                 loop: true,
                 autoplay: true
             };
        }
    }
}
